import axios from "axios";
import { dominio } from "@/config/base";

const actions = {
  retrieveToken({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios.post(`${dominio}/login/user`, {
        usuario: credentials.usuario,
        password: credentials.password
      })
      .then(response => {
        if (response.data.ok === true) {
          const token = response.data.data.token;
          const user = response.data.data.user;

          localStorage.setItem('access_token', token);
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('type', user.type);

          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

          commit('retrieveToken', token);
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(error => {
        reject(error);
      });
    });
  },

  destroyToken({ commit, getters }) {
    if (getters.loggedIn) {
      return new Promise((resolve, reject) => {
        axios.post(`${dominio}/logout`) // POST recomendado por seguridad
          .then(response => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            localStorage.removeItem('type');
            commit('destroyToken');
            delete axios.defaults.headers.common['Authorization'];
            resolve(response);
          })
          .catch(error => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            localStorage.removeItem('type');
            commit('destroyToken');
            delete axios.defaults.headers.common['Authorization'];
            reject(error);
          });
      });
    }
  }
};

export default actions;
